"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.formatTelHref = void 0;
var formatTelHref = function formatTelHref(string) {
  if (typeof string !== 'string') return string;
  var replacedNumber = string.replace(/ /g, '').replace(/-/g, '');
  return string.startsWith('tel:') ? replacedNumber : "tel:".concat(replacedNumber);
};
exports.formatTelHref = formatTelHref;
var _default = formatTelHref;
exports.default = _default;